import { cn } from '@/utils/cn';

interface ErrorAlertProps {
  message: string;
  /** The API's request id, so support can find the failing request in the logs. */
  requestId?: string;
  className?: string;
}

export function ErrorAlert({ message, requestId, className }: ErrorAlertProps) {
  return (
    <div
      role="alert"
      className={cn('rounded-lg bg-danger/10 px-3 py-2 text-sm text-danger', className)}
    >
      {message}
      {requestId && <span className="mt-0.5 block text-xs opacity-80">Reference: {requestId}</span>}
    </div>
  );
}
